import { render, staticRenderFns } from "./HorizontalLine.vue?vue&type=template&id=01c5c0fe"
import script from "./HorizontalLine.vue?vue&type=script&lang=js"
export * from "./HorizontalLine.vue?vue&type=script&lang=js"
import style0 from "./HorizontalLine.vue?vue&type=style&index=0&id=01c5c0fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports